var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _path4, _rect6, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect7, _path12, _path13, _path14, _rect8, _path15, _path16, _rect9, _rect10, _rect11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionnaireEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 102,
    viewBox: "0 0 132 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.592 41.8924L78.7418 6.85604C73.4782 1.56426 64.9441 1.56426 59.6806 6.85604L24.6511 42.0731C23.3851 43.3475 22.675 45.0711 22.6758 46.8673V46.8673L69.2112 72.5865L115.747 46.8673V46.8673C115.68 44.9968 114.911 43.2202 113.592 41.8924Z",
    fill: "#3E4452",
    stroke: "#8591A6",
    strokeWidth: 0.3045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.1523,
    y: 7.18848,
    width: 64.4694,
    height: 64.814,
    rx: 10.6471,
    fill: "#848B9D",
    stroke: "#2E2E2E",
    strokeWidth: 0.3045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.9121,
    y: 10.374,
    width: 72.6003,
    height: 72.9884,
    rx: 10.6471,
    fill: "#848B9D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.9121,
    y: 10.374,
    width: 72.6003,
    height: 72.9884,
    rx: 10.6471,
    stroke: "#2E2E2E",
    strokeWidth: 0.3045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 41.6211,
    y: 25.1367,
    width: 55.1813,
    height: 6.90258,
    rx: 1.11349,
    fill: "#848B9D",
    stroke: "#3E4452",
    strokeWidth: 0.3045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 41.6211,
    y: 37.459,
    width: 37.671,
    height: 6.90258,
    rx: 1.11349,
    fill: "#848B9D",
    stroke: "#3E4452",
    strokeWidth: 0.3045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6758 46.8682V84.2506C22.6709 88.2678 24.0935 92.156 26.6899 95.2215L59.3287 67.1255L22.6758 46.8682Z",
    fill: "#3E4452",
    stroke: "#8591A6",
    strokeWidth: 0.3045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.747 46.8682L79.0938 67.1255L111.732 95.2215C114.329 92.1561 115.751 88.2678 115.747 84.2506L115.747 46.8682Z",
    fill: "#3E4452",
    stroke: "#8591A6",
    strokeWidth: 0.3045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0953 67.1264L74.0961 62.8231C71.29 60.4037 67.1355 60.4037 64.3294 62.8231L59.3302 67.1264L26.6914 95.2224C29.7876 98.8887 34.3984 101.222 39.5569 101.222H98.8686C104.027 101.222 108.638 98.8887 111.734 95.2224L79.0953 67.1264Z",
    fill: "#3E4452",
    stroke: "#8591A6",
    strokeWidth: 0.3045,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.921875,
    y: 40.2944,
    width: 43.5093,
    height: 23.5202,
    rx: 2.83253,
    fill: "#4D515F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30351 46.9849H9.05817C8.57192 46.9849 8.17773 47.3395 8.17773 47.7771V58.3771C8.17773 58.8146 8.57191 59.1693 9.05817 59.1693H9.30351C9.78977 59.1693 10.184 58.8146 10.184 58.3771V47.7771C10.184 47.3395 9.78977 46.9849 9.30351 46.9849Z",
    fill: "#768297"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0115 52.103H13.3463C12.976 52.103 12.6758 52.3731 12.6758 52.7063V58.566C12.6758 58.8991 12.976 59.1692 13.3463 59.1692H14.0115C14.3818 59.1692 14.682 58.8991 14.682 58.566V52.7063C14.682 52.3731 14.3818 52.103 14.0115 52.103Z",
    fill: "#768297"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4729 51.3088H17.881C17.4904 51.3088 17.1738 51.5937 17.1738 51.9451V58.5327C17.1738 58.8841 17.4904 59.169 17.881 59.169H18.4729C18.8635 59.169 19.1801 58.8841 19.1801 58.5327V51.9451C19.1801 51.5937 18.8635 51.3088 18.4729 51.3088Z",
    fill: "#768297"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7285 44.9377H22.6254C22.0999 44.9377 21.6738 45.3211 21.6738 45.7939V58.314C21.6738 58.7869 22.0999 59.1702 22.6254 59.1702H22.7285C23.254 59.1702 23.6801 58.7869 23.6801 58.314V45.7939C23.6801 45.3211 23.254 44.9377 22.7285 44.9377Z",
    fill: "#768297"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2977 46.9849H27.0523C26.5661 46.9849 26.1719 47.3395 26.1719 47.7771V58.3771C26.1719 58.8146 26.5661 59.1693 27.0523 59.1693H27.2977C27.7839 59.1693 28.1781 58.8146 28.1781 58.3771V47.7771C28.1781 47.3395 27.7839 46.9849 27.2977 46.9849Z",
    fill: "#768297"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8724 48.9668H31.4775C31.0325 48.9668 30.6719 49.2913 30.6719 49.6917V58.4444C30.6719 58.8448 31.0326 59.1693 31.4775 59.1693H31.8724C32.3174 59.1693 32.6781 58.8448 32.6781 58.4444V49.6917C32.6781 49.2913 32.3174 48.9668 31.8724 48.9668Z",
    fill: "#768297"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2957 46.9849H36.0504C35.5641 46.9849 35.1699 47.3395 35.1699 47.7771V58.3771C35.1699 58.8146 35.5641 59.1693 36.0504 59.1693H36.2957C36.7819 59.1693 37.1762 58.8146 37.1762 58.3771V47.7771C37.1762 47.3395 36.7819 46.9849 36.2957 46.9849Z",
    fill: "#768297"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 96.2598,
    y: 0.780518,
    width: 34.816,
    height: 23.491,
    rx: 1.45737,
    fill: "#4D515F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M113.351 12.8661C114.352 12.8201 115.345 13.0587 116.215 13.5542L120.205 6.07658C117.993 4.85835 115.487 4.27698 112.964 4.39705C106.793 4.68188 101.757 9.00448 100.264 14.7096L108.42 16.8699C109 14.6549 110.955 12.9767 113.351 12.8661Z",
    fill: "#768297"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.824 17.1139L127.074 15.3355C126.237 11.3981 123.73 8.01893 120.205 6.07666L116.215 13.5543C117.554 14.3123 118.504 15.6084 118.824 17.1139Z",
    fill: "#8591A6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M113.281 6.08836L111.521 17.671C111.516 17.7009 111.523 17.7313 111.539 17.7568L113.299 20.5841C113.371 20.7002 113.584 20.7002 113.656 20.5841L115.415 17.7568C115.432 17.7314 115.438 17.7009 115.434 17.671L113.674 6.08837C113.647 5.90642 113.308 5.90642 113.281 6.08836Z",
    fill: "#414655"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 124.857,
    y: 82.1914,
    width: 34.5308,
    height: 20.3808,
    rx: 1.3519,
    transform: "rotate(-180 124.857 82.1914)",
    fill: "#4D515F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106.782 66.8C105.371 65.302 103.404 64.4531 101.346 64.4541V66.3736C102.88 66.3729 104.347 67.0059 105.4 68.1229C106.393 69.1696 106.945 70.5582 106.943 72.0011H108.853C108.855 70.066 108.114 68.2038 106.782 66.8Z",
    fill: "#8591A6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.942 72.0012C106.942 75.1092 104.436 77.6287 101.345 77.6287C98.2461 77.618 95.7414 75.0999 95.7473 72.0012C95.7473 68.8933 98.2533 66.3737 101.345 66.3737V64.4541C97.1989 64.4541 93.8379 67.8331 93.8379 72.0012C93.835 73.9363 94.5763 75.7985 95.9082 77.2023C97.3195 78.7003 99.2867 79.5491 101.345 79.5482C105.491 79.5482 108.852 76.1693 108.852 72.0012H106.942Z",
    fill: "#768297"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 112.219,
    y: 67.957,
    width: 6.94415,
    height: 1.61722,
    rx: 0.80646,
    fill: "#768297"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 112.219,
    y: 74.4282,
    width: 10.2663,
    height: 1.61722,
    rx: 0.80646,
    fill: "#768297"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 112.219,
    y: 71.1936,
    width: 5.2854,
    height: 1.61722,
    rx: 0.80646,
    fill: "#768297"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionnaireEnvelope);
export default __webpack_public_path__ + "static/media/questionnaire-envelope.e11d2f031dda47ec4e89fc0bbebf7870.svg";
export { ForwardRef as ReactComponent };